export const windowButtons = {
	close: "Close",
	hide: "Minimize",
	max: "Maximize",
	help: "Help",
};
